import { render, staticRenderFns } from "./Facturable.vue?vue&type=template&id=2c58af42&"
import script from "./Facturable.vue?vue&type=script&lang=js&"
export * from "./Facturable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports